import type { HTMLAttributes, ReactNode } from 'react';

import { cx } from '../cx';

export type ThemeName = 'dark' | 'light' | 'red' | 'admin';

export type ThemeProps = HTMLAttributes<HTMLDivElement> & {
  /** `dark` no site publico, `admin` no back-office; `light` e `red` para secoes. */
  name: ThemeName;
  children: ReactNode;
};

/**
 * Aplica um tema a tudo o que esta dentro. Os temas podem encaixar-se: uma faixa
 * `red` dentro de uma pagina `dark` muda so as cores dessa faixa.
 */
export function Theme({ name, className, children, ...props }: ThemeProps) {
  return (
    <div data-gu-theme={name} className={cx('bg-gu-ground text-gu-ink', className)} {...props}>
      {children}
    </div>
  );
}
